import {Status as AutomationFileStatusGraphQL} from 'graphql-client/__generated/graphqlGlobalTypes';

import {AutomationOutputFileGraphQL} from '../../../graphql-fragments/lab-automation/__generated/AutomationOutputFileGraphQL';
import {ListAutomationOutputFiles_automationOutputFiles_AutomationOutputFileNode as ListAutomationOutputFile} from './__generated/ListAutomationOutputFiles';

type LiveAutomationOutputFile = ListAutomationOutputFile;

export default function getStatusForOutputFileButton(
  automationOutputFile: AutomationOutputFileGraphQL | LiveAutomationOutputFile
): AutomationFileStatusGraphQL {
  if (automationOutputFile.status === AutomationFileStatusGraphQL.failed) {
    return automationOutputFile.status;
  }
  if (automationOutputFile.transforms) {
    for (const transform of automationOutputFile.transforms) {
      if (
        transform &&
        [AutomationFileStatusGraphQL.running, AutomationFileStatusGraphQL.failed].includes(transform.status)
      ) {
        return transform.status;
      }
    }
  }
  return automationOutputFile.status;
}
